import React, { useContext, useEffect, useState } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';

// Since there's not a way of appending to I18nModel right now
// using this method. Will talk with yuzhong about support for this
const getData = i18n => i18n.p$data.value().resource.data;

export const mergeI18n = (target, parentI18n) => {
  Object.assign(getData(target), getData(parentI18n));
  return target;
};

/* This is to merge the parent and child i18n(App and Feature) */
export const withMergedI18n = (Component, $getI18n) => (props) => {
  const parentI18n = useContext(I18nContext);
  const [i18n, setI18n] = useState(null);

  useEffect(() => {
    $getI18n.then(({ default: childI18n }) => {
      childI18n.ready().then(() => {
        setI18n(mergeI18n(childI18n, parentI18n));
      });
    });
  }, [parentI18n]);

  if (!i18n) return null;

  return (
    <I18nContext.Provider value={i18n}>
      <Component {...props} i18n={i18n} />
    </I18nContext.Provider>
  );
};
